import { Router } from '@reach/router';
import React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from '../../hooks/useTranslation';
import ROUTES from '../../routes';
import ChargepointSubmitted from '../../components/chargepoint/ChargepointSubmitted';

export const ChargepointSuccess = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('CHARGEPOINT SUBMITTED')}</title>
      </Helmet>

      <Router basepath="/">
        <ChargepointSubmitted path={`${ROUTES.CHARGEPOINTSUBMIT}/*`} />
      </Router>
    </>
  );
};
export default ChargepointSuccess;
